(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accessory-row"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accessory-size-select')) {
    customElements.define(
      'accessory-size-select',
      class AccessorySizeSelect extends HTMLElement {
        connectedCallback() {
          this.select = this.querySelector('select');
          this.select?.addEventListener('change', this.sync);
          this.sync();
        }

        disconnectedCallback() {
          this.select?.removeEventListener('change', this.sync);
        }

        // Copies the picked size into the form's id input and enables the add button only when a
        // size is picked. ProductFormComponent.handleSubmit returns early on a disabled button.
        sync = () => {
          const row = this.closest('li');
          const input = row?.querySelector('input[name="id"]');
          const button = row?.querySelector('[ref="addToCartButton"]');
          if (!this.select || !input || !button) return;

          input.value = this.select.value;
          button.disabled = !this.select.value;
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
